var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.76664L5 3.30664",
    stroke: "#6B7280",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.1667V5.83335C13.9998 5.59953 13.938 5.36989 13.821 5.16746C13.704 4.96503 13.5358 4.79692 13.3333 4.68002L8.66667 2.01335C8.46397 1.89633 8.23405 1.83472 8 1.83472C7.76595 1.83472 7.53603 1.89633 7.33333 2.01335L2.66667 4.68002C2.46418 4.79692 2.29599 4.96503 2.17897 5.16746C2.06196 5.36989 2.00024 5.59953 2 5.83335V11.1667C2.00024 11.4005 2.06196 11.6301 2.17897 11.8326C2.29599 12.035 2.46418 12.2031 2.66667 12.32L7.33333 14.9867C7.53603 15.1037 7.76595 15.1653 8 15.1653C8.23405 15.1653 8.46397 15.1037 8.66667 14.9867L13.3333 12.32C13.5358 12.2031 13.704 12.035 13.821 11.8326C13.938 11.6301 13.9998 11.4005 14 11.1667Z",
    stroke: "#6B7280",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18005 5.14001L8.00005 8.50668L13.8201 5.14001",
    stroke: "#6B7280",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.22V8.5",
    stroke: "#6B7280",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.f539f3c3.svg";
export { ForwardRef as ReactComponent };